import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../stores/useAuthStore';
import { APP_HOME } from '../utils/segment';

const AdminRoute: React.FC = () => {
    const { user, isLoading } = useAuthStore();
    const navigate = useNavigate();

    useEffect(() => {
        if (!isLoading && (!user || user.role !== 'admin')) {
            navigate(APP_HOME, { replace: true });
        }
    }, [user, isLoading, navigate]);

    if (isLoading) {
        return (
            <div className="min-h-screen bg-snapfy-bg flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#7063f7]"></div>
            </div>
        );
    }

    if (!user || user.role !== 'admin') {
        return null;
    }

    return <Outlet />;
};

export default AdminRoute;
